
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("a5rdE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $10Oe6 = parcelRequire("10Oe6");

const $3df8122831711c20$var$PreviewAnalyticsContextDefaultValue = {
    fireAnalyticsEvent: (_payload)=>{},
    fireAnalyticsEventWithTemplateData: (_payload)=>{}
};
const $3df8122831711c20$export$7edca4dea2d0dcb = /*#__PURE__*/ (0, $42omo.createContext)($3df8122831711c20$var$PreviewAnalyticsContextDefaultValue);
const $3df8122831711c20$export$ddfa06b4d6bebe9 = ({ template: template, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const contextValue = (0, $42omo.useMemo)(()=>({
            fireAnalyticsEvent: (payload)=>{
                createAnalyticsEvent({
                    ...payload,
                    data: {
                        ...payload.data,
                        attributes: {
                            ...payload.data.attributes
                        }
                    }
                }).fire();
            },
            fireAnalyticsEventWithTemplateData: (payload)=>{
                if (!template) return;
                createAnalyticsEvent({
                    ...payload,
                    data: {
                        ...payload.data,
                        attributes: {
                            ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template),
                            ...payload.data.attributes
                        }
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        template
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3df8122831711c20$export$7edca4dea2d0dcb.Provider, {
        value: contextValue
    }, children);
};
module.exports["PreviewAnalyticsContext"] = $3df8122831711c20$export$7edca4dea2d0dcb;
module.exports["PreviewAnalyticsProvider"] = $3df8122831711c20$export$ddfa06b4d6bebe9;

});

parcelRegister("2dIMm", function(module, exports) {
/* PreviewMessage.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $03f53654055bcbe2$var$CenteredContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            __cmplp.className
        ])
    });
});
const $03f53654055bcbe2$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2fwxA5DIqT",
            __cmplp.className
        ])
    });
});
const $03f53654055bcbe2$var$Icon = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1frub2c": (0, $7sObp.default)(__cmplp.size, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_0jFU0V59Fr",
            __cmplp.className
        ])
    });
});
const $03f53654055bcbe2$var$Title = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2sNsIgWSk4 _2XghbEBuOf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03f53654055bcbe2$var$Message = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2sNsIgmnOE _2XghbEyvmg _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $03f53654055bcbe2$export$7cf0d92c25454dc3 = ({ title: title, message: message, icon: icon, iconDescription: iconDescription, testId: testId, iconSize: iconSize = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($03f53654055bcbe2$var$CenteredContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($03f53654055bcbe2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($03f53654055bcbe2$var$Icon, {
        src: icon,
        alt: iconDescription,
        size: iconSize === 'small' ? 135 : 240
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($03f53654055bcbe2$var$Title, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($03f53654055bcbe2$var$Message, null, message)));
module.exports["PreviewMessage"] = $03f53654055bcbe2$export$7cf0d92c25454dc3;

});

parcelRegister("dro0K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $2dIMm = parcelRequire("2dIMm");

var $043a096459a0f154$exports = {};
$043a096459a0f154$exports = new URL("displayErrorIcon.3bd706b2.svg", import.meta.url).toString();


const $8d6763054422cd04$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    title: {
        id: "template-preview.errors.display.title",
        defaultMessage: "Nothing to see until you add it"
    },
    message: {
        id: "template-preview.errors.display.message",
        defaultMessage: "There\u2019s no preview available for this template {lineBreak} because it\u2019s tailored to details you provide."
    },
    iconDescription: {
        id: "template-preview.errors.display.icon.description",
        defaultMessage: "Can\u2019t display the preview"
    }
});
const $8d6763054422cd04$export$58e94af4983e44b2 = (0, $aXWIB.injectIntl)(({ intl: intl, error: error })=>{
    const handleExperiences = error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        error: error,
        name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2dIMm.PreviewMessage), {
        title: intl.formatMessage($8d6763054422cd04$export$a7357cdd1f0b0168.title),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$8d6763054422cd04$export$a7357cdd1f0b0168.message,
            values: {
                lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }
        }),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($043a096459a0f154$exports))),
        iconDescription: intl.formatMessage($8d6763054422cd04$export$a7357cdd1f0b0168.iconDescription),
        testId: "template-no-preview-available"
    }), handleExperiences);
});
module.exports["NoPreviewAvailable"] = $8d6763054422cd04$export$58e94af4983e44b2;

});

parcelRegister("h2spB", function(module, exports) {
/* AdfPreviewRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $67O0h = parcelRequire("67O0h");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $bQm3c = parcelRequire("bQm3c");


var $kLzei = parcelRequire("kLzei");


var $kBU5m = parcelRequire("kBU5m");


var $1SPMi = parcelRequire("1SPMi");


var $ep3mz = parcelRequire("ep3mz");


var $6M71K = parcelRequire("6M71K");


var $dro0K = parcelRequire("dro0K");


var $a5rdE = parcelRequire("a5rdE");


var $7VJPz = parcelRequire("7VJPz");





var $dwS6P = parcelRequire("dwS6P");


var $5kjCz = parcelRequire("5kjCz");





var $aXWIB = parcelRequire("aXWIB");


var $eEA8O = parcelRequire("eEA8O");

const $7323171455a0d879$var$i18n = (0, $aXWIB.defineMessages)({
    createFromTemplateDefaultLabelText: {
        id: "template-preview.inline-extension.create-from-template",
        defaultMessage: "Create from Template"
    }
});
const $7323171455a0d879$export$4650ed166f7e10ba = (ext)=>{
    const { buttonLabel: buttonLabel, createButtonLabel: createButtonLabel } = ext.parameters?.macroParams;
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), null, buttonLabel?.value || createButtonLabel?.value || intl.formatMessage($7323171455a0d879$var$i18n.createFromTemplateDefaultLabelText));
};


const $40c2235e2dccc44b$export$761d78657661dea6 = ({ adf: adf, cloudId: cloudId, userId: userId, contentId: contentId, spaceKey: spaceKey })=>{
    return (ext)=>{
        const macroDefaultProps = {
            node: ext,
            extensionKey: ext.extensionKey,
            contentId: contentId || '',
            mode: (0, $5kjCz.RENDERER),
            spaceKey: spaceKey || ''
        };
        // some extensions can handle anon users, so change null userId to ""
        const extensionProps = {
            userId: userId || '',
            cloudId: cloudId,
            adf: adf,
            macroDefaultProps: macroDefaultProps
        };
        switch(ext.extensionKey){
            case 'create-from-template':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7323171455a0d879$export$4650ed166f7e10ba), ext);
            case 'toc':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwS6P.LazyTableOfContentsLoader), extensionProps);
            default:
                return null;
        }
    };
};









var $b4zhJ = parcelRequire("b4zhJ");


var $2igSQ = parcelRequire("2igSQ");


var $ge2sX = parcelRequire("ge2sX");


var $9914C = parcelRequire("9914C");

const $f63d4f2218056824$export$ae40814dbdc558b6 = (0, $aXWIB.defineMessages)({
    documentOwner: {
        id: "template-preview.custom-blueprint-variable-handler.document-owner",
        defaultMessage: "Document owner"
    }
});
const $f63d4f2218056824$export$fb67b4c81279b22e = ({ template: template })=>{
    return (ext)=>{
        if (ext.extensionKey === 'variable') {
            const { type: type, name: name, params: params } = ext.parameters;
            const isTemplate = template?.templateId;
            switch(name){
                case 'currentDateLozenge':
                case 'createdDate':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, ({ userId: userId, isLicensed: isLicensed, timeZone: timeZone })=>{
                        const currentDate = (0, $9914C.getUserTimezoneDate)({
                            userId: userId,
                            isLicensed: isLicensed,
                            timeZone: timeZone,
                            dateFormat: 'yyyy/MM/dd'
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b4zhJ.Date), {
                            value: Date.parse(currentDate),
                            format: "MMM d, yyyy"
                        });
                    });
                default:
                    return isTemplate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2igSQ.TemplateVariableInput), {
                        parameters: {
                            name: name,
                            type: type,
                            params: params,
                            isDisabled: true
                        }
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f63d4f2218056824$var$BlueprintVariablePreview, {
                        ext: ext
                    });
            }
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f63d4f2218056824$var$DefaultExtensionHandlerComponent, null);
    };
};
const $f63d4f2218056824$var$BlueprintVariablePreview = (0, $aXWIB.injectIntl)(({ ext: ext, intl: intl })=>{
    const { type: type, name: name, params: params } = ext.parameters;
    const userFriendlyVariableNameI18n = $f63d4f2218056824$export$ae40814dbdc558b6[name];
    return userFriendlyVariableNameI18n ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2igSQ.TemplateVariableInput), {
        parameters: {
            name: intl.formatMessage(userFriendlyVariableNameI18n),
            type: type,
            params: params,
            isDisabled: true
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f63d4f2218056824$var$DefaultExtensionHandlerComponent, null);
});
const $f63d4f2218056824$var$DefaultExtensionHandlerComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "other-extension"
    });


const $9cb98e8b9a980e76$export$fe33197d44e10fcf = (extensionHandlerArgs)=>{
    return {
        'com.atlassian.confluence.macro.core': (0, $40c2235e2dccc44b$export$761d78657661dea6)(extensionHandlerArgs),
        'com.atlassian.confluence.template': (0, $f63d4f2218056824$export$fb67b4c81279b22e)(extensionHandlerArgs),
        'com.atlassian.automation.smart-button': (0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
            contentId: extensionHandlerArgs.contentId,
            contentType: 'page',
            cloudId: extensionHandlerArgs.cloudId
        })['com.atlassian.automation.smart-button']
    };
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f480df1be441efc8$var$FixTableHorizontalScrollbars = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { allowTableResizing: allowTableResizing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            !__cmplp.allowTableResizing && "_3PlZvIU77s _2SvtzAU77s _2rFesgOiJt",
            __cmplp.className
        ])
    });
});
const $f480df1be441efc8$export$d1901e4b3edd92d4 = ({ template: template, allowTableResizing: allowTableResizing = false, previewString: previewString, fabricDataProviders: fabricDataProviders })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { featureFlags: featureFlags, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { fireAnalyticsEventWithTemplateData: fireAnalyticsEventWithTemplateData } = (0, $42omo.useContext)((0, $a5rdE.PreviewAnalyticsContext));
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let adf;
    try {
        adf = JSON.parse(previewString);
    } catch (e) {
        fireAnalyticsEventWithTemplateData({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'error',
                actionSubject: 'templatePreview',
                actionSubjectId: 'templatePreviewAdfParsingError',
                attributes: {
                    errorMessage: e.message
                }
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dro0K.NoPreviewAvailable), {
            error: e
        });
    }
    const experienceSuccess = ()=>experienceTracker.succeed({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE)
        });
    const experienceFailure = (error)=>experienceTracker.fail({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
            error: error
        });
    const extensionHandlers = (0, $9cb98e8b9a980e76$export$fe33197d44e10fcf)({
        adf: adf,
        cloudId: cloudId,
        userId: userId,
        contentId: contentId,
        spaceKey: spaceKey,
        template: template
    });
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        source: "templatePreview"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.default), {
        adfStage: "stage0",
        document: adf,
        appearance: "full-page",
        allowColumnSorting: false,
        enableSsrInlineScripts: false,
        allowHeadingAnchorLinks: false,
        stickyHeaders: undefined,
        dataProviders: fabricDataProviders,
        extensionHandlers: extensionHandlers,
        key: previewString,
        onComplete: experienceSuccess,
        onError: experienceFailure,
        allowPlaceholderText: true,
        media: {
            featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags)
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f480df1be441efc8$var$FixTableHorizontalScrollbars, {
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), (0, $kLzei.getSmartCardRenderers)(), content));
};
module.exports["AdfPreviewRenderer"] = $f480df1be441efc8$export$d1901e4b3edd92d4;

});


//# sourceMappingURL=TemplatePreview.00b3b3ad.js.map
